import {Component} from '@angular/core';
import {CommonService} from "../../core/services/common.service";
import {ToastService} from "../../core/services/toast.service";
import {AffiliateService} from "../../core/services/affiliate.service";

interface CatalogMin {
  catalogId: number;
  title: string;
  brand: string;
  mop: number;
}

interface ProductMin {
  catalogId: number;
  createdAt?: string;
  status: string;
}
interface AffiliateView extends CatalogMin {
  detail?: ProductMin;
}

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrl: './links.component.css'
})
export class LinksComponent {
  customer: any;
  userCode: any;
  smartCode: any;
  affiliateLinks: AffiliateView[] = [];
  stats = [
    { title: 'Total Links', value: '0', icon: 'link', color: 'primary' },
    { title: 'Total Sales', value: '0', icon: 'trophy', color: 'warning' },
    { title: 'Total Conversions', value: '0', icon: 'cart', color: 'success' },
    { title: 'Total Earnings', value: '₹0.00', icon: 'wallet', color: 'danger' }
  ];
  constructor(private affiliateService: AffiliateService, private common: CommonService, private toast: ToastService) {
    this.customer = this.common.getStorage('customer');
    this.userCode = this.customer.firstName.charAt(0).toUpperCase() + this.customer.lastName.charAt(0).toUpperCase();
    this.smartCode = (this.userCode) + (this.customer.id);
  }

  ngOnInit() {
    this.loadAffiliateLinks();
    this.getStatistics();
  }

  loadAffiliateLinks() {
    this.affiliateService
      .linksByCustomer(this.customer.id)
      .subscribe({
        next: (res: any) => {
          const catalogsRaw = res?.response?.CatalogResponse ?? [];
          const productsRaw = res?.response?.ProductResponse ?? [];
          const catalogs: CatalogMin[] = catalogsRaw.map((c: any) => ({
            catalogId: Number(c.catalogId),
            title: c.title ?? '',
            brand: c.brand ?? '',
            mop: Number(c.mop) || 0
          }));

          const details: ProductMin[] = productsRaw.map((p: any) => ({
            catalogId: Number(p.catalogId),
            createdAt: p.createdAt ?? undefined,
            status: p.status ?? ''
          }));

          const detailById = new Map<number, ProductMin>();
          for (const d of details) {
            if (Number.isFinite(d.catalogId)) detailById.set(d.catalogId, d);
          }

          this.affiliateLinks = catalogs.map(c => ({
            ...c,
            detail: detailById.get(c.catalogId)
          }));
        },
        error: (err) => console.error('Failed to load affiliate links', err)
      });
  }

  copyToClipboard(text: string) {
    text = "Hi! I have joined as SmartSeller with SmartDukaan. Check out this great deal! \n"+text;
    navigator.clipboard.writeText(text).then(() => {
      this.toast.success("Link Copied to clipboard successfully")
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  }

  getStatistics() {
    this.affiliateService.getStatistics(this.customer.id).subscribe({
      next: (res) => {
        this.stats[0].value = res.response.affiliateLinks?.length || 0;
        this.stats[1].value = res.response.affiliateOrders?.length || 0;
        this.stats[2].value = res.response.affiliateOrders?.length || 0;
        this.stats[3].value = '₹'+(res.response.affiliateEarnings.reduce((sum, r) => sum + (r.amount ?? 0), 0)).toFixed(2);
      },
      error: (err) => {
        console.error("Error loading stats", err);
      }
    });
  };

}
